module.exports = __webpack_public_path__ + "img/merchantID-top.54e8e09a.svg";